<div class="search-bar" [ngClass]="{disabled: isDisabled}">
  <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
    <input
      #searchArea
      type="text"
      [placeholder]="
        displaySearchError
          ? ('browse.search.errorMessage' | translate)
          : ('browse.search.placeholder' | translate)
      "
      formControlName="term"
      [ngClass]="{ 'with-error': displaySearchError }"
      (input)="onChangeSearchTerm($event.target.value)"
    />
    <button class="search-btn" [ngClass]="{ invalid: searchForm.invalid }">
      <span class="icon icon-search"></span>
    </button>
  </form>
</div>
